import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { css } from 'styled-components';
import { createComponent } from '../utils';
import { createEasyInput } from './EasyInput';
var SwitchThumb = createComponent({
    name: 'SwitchThumb',
    as: 'i',
    style: function (_a) {
        var trackInset = _a.trackInset, thumbSize = _a.thumbSize, value = _a.value;
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: ", "px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    height: ", "px;\n    width: ", "px;\n    background-color: white;\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s cubic-bezier(0.125, 0.85, 0.3, 1.125);\n\n    ", ";\n  "], ["\n    border-radius: ", "px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    height: ", "px;\n    width: ", "px;\n    background-color: white;\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s cubic-bezier(0.125, 0.85, 0.3, 1.125);\n\n    ",
            ";\n  "])), thumbSize * 2, thumbSize - trackInset * 2, thumbSize - trackInset * 2, value && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      transform: translateX(", "px);\n    "], ["\n      transform: translateX(", "px);\n    "])), thumbSize));
    },
});
var SwitchTrack = createComponent({
    name: 'SwitchTrack',
    as: 'label',
    style: function (_a) {
        var theme = _a.theme, trackColor = _a.trackColor, thumbSize = _a.thumbSize, trackInset = _a.trackInset, value = _a.value, isFocused = _a.isFocused, _b = _a.colorFocus, colorFocus = _b === void 0 ? theme.colors.colorFocus : _b;
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    width: ", "px;\n    height: ", "px;\n    background: ", ";\n    border: ", "px solid ", ";\n    border-radius: ", "px;\n    transition: background-color 0.2s, border-color 0.2s;\n    z-index: 1;\n\n    &:active {\n      ", " {\n        transform: translateX(", "px);\n        width: ", "px;\n      }\n    }\n\n    &:before {\n      transition: opacity 250ms;\n      content: '';\n      position: absolute;\n      left: -", "px;\n      top: -", "px;\n      width: ", "px;\n      height: ", "px;\n      z-index: 0;\n      opacity: 0;\n    }\n\n    ", "\n  "], ["\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    width: ", "px;\n    height: ", "px;\n    background: ", ";\n    border: ", "px solid ", ";\n    border-radius: ", "px;\n    transition: background-color 0.2s, border-color 0.2s;\n    z-index: 1;\n\n    &:active {\n      ", " {\n        transform: translateX(", "px);\n        width: ", "px;\n      }\n    }\n\n    &:before {\n      transition: opacity 250ms;\n      content: '';\n      position: absolute;\n      left: -", "px;\n      top: -", "px;\n      width: ", "px;\n      height: ", "px;\n      z-index: 0;\n      opacity: 0;\n    }\n\n    ",
            "\n  "])), thumbSize * 2, thumbSize, value ? theme.colors[trackColor] : 'transparent', trackInset, value ? theme.colors[trackColor] : theme.colors.grey, thumbSize, SwitchThumb, value ? thumbSize - trackInset * 3 : 0, thumbSize + trackInset, trackInset + 4, trackInset + 4, thumbSize * 2, thumbSize, isFocused && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      &:before {\n        opacity: 1;\n        border: 4px solid ", ";\n        border-radius: ", "px;\n      }\n    "], ["\n      &:before {\n        opacity: 1;\n        border: 4px solid ", ";\n        border-radius: ", "px;\n      }\n    "])), colorFocus, thumbSize));
    },
});
var SwitchInput = createComponent({
    name: 'SwitchInput',
    as: 'input',
    style: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n    left: 1px;\n    white-space: nowrap;\n  "], ["\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n    left: 1px;\n    white-space: nowrap;\n  "]))),
});
var Switch = (function (_super) {
    __extends(Switch, _super);
    function Switch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: !!_this.props.value,
            isFocused: false,
        };
        _this.handleChange = function () {
            var _a = _this.props, onChange = _a.onChange, name = _a.name;
            if (typeof onChange === 'function') {
                onChange(name, !_this.state.value);
            }
            else {
                _this.setState(function (state) { return ({ value: !state.value }); });
            }
        };
        _this.handleFocus = function () {
            _this.setState({ isFocused: !_this.state.isFocused });
        };
        return _this;
    }
    Switch.getDerivedStateFromProps = function (props, state) {
        if (props.value !== undefined && props.value !== state.value) {
            return {
                value: props.value,
            };
        }
        return null;
    };
    Switch.prototype.render = function () {
        var _a = this.props, name = _a.name, thumbSize = _a.thumbSize, trackInset = _a.trackInset, colorFocus = _a.colorFocus, props = __rest(_a, ["name", "thumbSize", "trackInset", "colorFocus"]);
        var _b = this.state, value = _b.value, isFocused = _b.isFocused;
        var sharedProps = {
            value: value,
            thumbSize: thumbSize,
            trackInset: trackInset,
            isFocused: isFocused,
        };
        return (React.createElement(SwitchTrack, __assign({ colorFocus: colorFocus }, props, sharedProps),
            React.createElement(SwitchInput, { name: name, type: "checkbox", onChange: this.handleChange, onFocus: this.handleFocus, onBlur: this.handleFocus }),
            React.createElement(SwitchThumb, __assign({}, sharedProps))));
    };
    Switch.defaultProps = {
        trackColor: 'primary',
        trackInset: 2,
        thumbSize: 24,
    };
    return Switch;
}(React.Component));
export { Switch };
export default createEasyInput(Switch);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Switch.js.map